import { QueryClientContext } from "../../context/QueryClientContext";
import { useListHosting } from "../../api/useHosting";
import { lang } from "../../utilities/lang";

const euroFormatter = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export const Hosting = () => {
    return (
        <QueryClientContext>
            <Content />
        </QueryClientContext>
    );
};

const Price = ({
    title,
    price,
    discount,
    postfix,
    className,
}: {
    price: number;
    discount: number | null;
    title?: string;
    postfix?: string;
    className?: string;
}) => {
    const hasDiscount = discount !== null;
    return (
        <div className={`hosting-price ${className}`}>
            {title ? <strong>{title}</strong> : null}
            <span className={`cost ${hasDiscount ? "discount" : ""}`}>{euroFormatter.format(price / 100)}</span>
            {hasDiscount ? <span className={`cost`}>{euroFormatter.format(discount / 100)}</span> : null}
            {postfix ? <span>{postfix}</span> : null}
        </div>
    );
};

const Content = () => {
    const hostingQuery = useListHosting();
    const hostingData = hostingQuery.isSuccess ? hostingQuery.data.data : [];

    return (
        <ul className={"hosting-list"}>
            {hostingData.map((hosting, index) => {
                return (
                    <li key={index} className={"hosting-entry"}>
                        <div className={"top"}>
                            <h2 className={"name"}>{hosting.name}</h2>
                        </div>
                        <div
                            className={"description"}
                            ref={(e) => {
                                if (e) {
                                    e.innerHTML = hosting.description;
                                }
                            }}
                        ></div>
                        <div className={"prices"}>
                            <Price
                                postfix={`/ ${lang.get("Jahr")}`}
                                price={hosting.price}
                                discount={hosting.price_discounted}
                                className={"subscription"}
                            />
                            <Price
                                title={lang.get("Einrichtung")}
                                price={hosting.setup_price}
                                discount={hosting.setup_price_discounted}
                                className={"setup"}
                            />
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};
